import { CardContent, Grid, Paper, Tooltip, Typography } from '@material-ui/core';
import React from 'react';

import {
  ILiveDataKPIsDisplay,
  ILiveDataKPIsDisplayItem,
} from '~/src/dash/components/live-data/live-data';

interface IProps {
  entries: ILiveDataKPIsDisplay;
  classes: { [key: string]: string };
  inventorySplitActive?: boolean;
}

export const LiveDataKPIs = (props: IProps) => {
  const { entries, classes, inventorySplitActive } = props;
  return (
    <Grid
      item
      style={{
        width: '100%',
        padding: '0px 16px',
      }}
    >
      <Grid container justifyContent='flex-start' alignItems='center' spacing={2}>
        {Object.keys(entries).map(
          (key: 'Site Revenue' | 'Site Impressions' | 'Site Render Rate') => {
            const entry =
              entries[key] || ({ value: '', sign: 1, displayName: '' } as ILiveDataKPIsDisplayItem);
            const disabled = inventorySplitActive && ['Stream Start'].includes(key);
            return (
              <Grid item key={key} lg={2} md={3} sm={4} xs={6}>
                <Paper
                  style={{
                    backgroundColor: '#FBFCFF',
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0,
                    boxShadow: '0px 2px 2px #E2E2E2',
                  }}
                >
                  <Tooltip
                    title={!disabled ? '' : 'Metric inactive while inventory split active'}
                    disableFocusListener={!disabled}
                    disableHoverListener={!disabled}
                    disableTouchListener={!disabled}
                  >
                    <CardContent style={{ paddingBottom: 8, paddingTop: 8 }}>
                      <Typography
                        className={disabled ? classes.cardTitleDisabled : classes.cardTitle}
                      >
                        {entry.displayName}
                      </Typography>
                      <Typography
                        className={disabled ? classes.cardValueDisabled : classes.cardValue}
                      >
                        {entry.value}
                      </Typography>
                    </CardContent>
                  </Tooltip>
                </Paper>
              </Grid>
            );
          },
        )}
      </Grid>
    </Grid>
  );
};
